import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import Preload from '../../js/components/preloader.js';
import { url } from '../../js/api/endpoint';
import language from '../../js/stores/language.js';
import themes from '../../js/stores/theme.js';
import user from '../../js/stores/user.js';
import car from '../../js/stores/car.js';
import contact from '../../js/stores/contact.js';
import file from '../../js/stores/file.js';
import place from '../../js/stores/place.js';
import { FileUploadWithPreview } from 'file-upload-with-preview';
import Croppie from 'croppie/croppie.min.js';
import Uploader from '../../js/controllers/uploader.js';
import CarDataTab from '../car/components/data-tab.f7.html';
import googleMaps from '../../js/controllers/google-map-lib.js';
import '../../css/croppie-edit.css';
function framework7Component(props, _ref) {
  var $ = _ref.$,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $f7route = _ref.$f7route,
    $f7router = _ref.$f7router;
  var locale = language.getters.Item.value;
  var data = props.CarMainData;
  var userTemp = {};
  var carItem = {};
  var uploader = null;
  var uploaderCar = null;
  var croppie = null;
  var uploadPersonal = null;
  var driverFileList = [];
  var driverLicensePhotos = [];
  var driverLicenseBrowser;
  var avatarFile = {};
  var avatarBlob = null;
  var isAvatarEmpty = false;
  var selectGender = null;
  var calendarModal = null;
  var autocomplete;
  var address1Field;
  var address2Field;
  var postalField;
  var selectProvince = null;
  var provinceList = [];
  var tabs = {
    'tab-1-button': 'tab-2-button',
    'tab-2-button': 'tab-3-button',
    'tab-3-button': 'tab-4-button',
    'tab-4-button': 'tab-1-button'
  };
  var openDriverBrowser = function openDriverBrowser() {
    driverLicenseBrowser.open();
  };
  var extraSetup = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var provinces;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return place.dispatch('getCountryProvinces');
          case 1:
            provinces = _context.sent;
            provinceList = provinces.map(function (item) {
              return {
                id: item.ProvinceId,
                text: item.ProvinceName
              };
            });
            $update();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function extraSetup() {
      return _ref2.apply(this, arguments);
    };
  }();
  var setProvinceLocalities = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var provinceId, localilities, localilitiesList, config, newObj;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            provinceId = selectProvince.getValue();
            _context2.next = 1;
            return place.dispatch('getProvincePlaces', provinceId);
          case 1:
            localilities = _context2.sent;
            localilitiesList = localilities.map(function (item) {
              return {
                id: item.LocationId,
                text: item.LocationName
              };
            });
            config = Preload.Autocomplete(localilitiesList, '#contact-locality', 'contact-locality-id');
            newObj = _objectSpread({}, config);
            $f7.autocomplete.destroy('#contact-locality');
            $f7.autocomplete.create(newObj);
            $update();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function setProvinceLocalities(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var avatarFileData, parts, tempDate, driverLicenseFiles, fileIds, i, urlFile, uploaderConfig, opts, croppieConfig;
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 1;
          return googleMaps.initAutocomplete("#contact");
        case 1:
          userTemp = {
            "id": user.getters.displayName.value.userId,
            "name": user.getters.displayName.value.userName,
            "email": user.getters.displayName.value.userEmail
          };
          _context4.next = 2;
          return file.dispatch('getUserAvatar', userTemp.id);
        case 2:
          avatarFileData = _context4.sent;
          if (avatarFileData.status !== undefined && avatarFileData.status !== 200) {
            console.log(avatarFileData.data.message);
            isAvatarEmpty = true;
          } else {
            avatarFile.fileId = avatarFileData.FileId;
            avatarFile.url = "".concat(url, "/").concat(avatarFileData.FilePath, "/").concat(avatarFileData.FileName);
            if (avatarFileData.FilePath.length == 0 && avatarFileData.FileName.length == 0) {
              isAvatarEmpty = true;
            }
          }
          selectGender = $f7.smartSelect.create({
            el: '#smart-select-gender',
            searchbar: false,
            closeOnSelect: 'true'
          });
          calendarModal = $f7.calendar.create({
            inputEl: '#demo-calendar-default',
            openIn: 'customModal',
            dateFormat: 'yyyy-mm-dd',
            header: true,
            footer: true,
            closeOnSelect: true,
            headerPlaceholder: locale.translate('user.edit.personal.contactBirthDateLabel'),
            toolbarCloseText: locale.translate('general.done')
          });
          if (data.ContactBirthDate != null) {
            parts = data.ContactBirthDate.split('-');
            tempDate = new Date(parts[0], parts[1] - 1, parts[2]);
            calendarModal.setValue([tempDate]);
          }
          selectProvince = $f7.smartSelect.create({
            el: '#smart-select-province',
            searchbar: false,
            closeOnSelect: 'true'
          });
          _context4.next = 3;
          return file.dispatch('getDriverLicense', data.ContactId);
        case 3:
          driverLicenseFiles = _context4.sent;
          fileIds = [];
          driverLicensePhotos = [];
          for (i = 0; i < driverLicenseFiles.length; i++) {
            fileIds.push(driverLicenseFiles[i].FileId);
            if (!(driverLicenseFiles[i].FilePath.length == 0 && driverLicenseFiles[i].FileName.length == 0)) {
              urlFile = "".concat(url, "/").concat(driverLicenseFiles[i].FilePath, "/").concat(driverLicenseFiles[i].FileName);
              driverLicensePhotos.push(urlFile);
            }
          }
          driverFileList = fileIds.join();
          if (driverLicensePhotos.length > 0) {
            driverLicenseBrowser = $f7.photoBrowser.create({
              photos: driverLicensePhotos,
              theme: themes.getters.Name.value
            });
          }
          uploadPersonal = new FileUploadWithPreview('my-unique-id', {
            maxFileCount: 2,
            multiple: true,
            accept: 'image/jpeg,image/jpg',
            text: {
              label: locale.translate('user.edit.personal.uploadLicenseLabel'),
              browse: locale.translate('general.browse'),
              chooseFile: locale.translate('general.chooseFileLabel'),
              selectedCount: locale.translate('general.selectedCountLabel')
            }
          });
          uploaderConfig = new Uploader({
            input: document.querySelector('.js-fileinput'),
            types: ['gif', 'jpg', 'jpeg', 'png']
          });
          opts = {
            viewport: {
              width: 240,
              height: 150
            },
            boundary: {
              width: 300,
              height: 300
            },
            showZoomer: true,
            enableResize: false,
            enableOrientation: true,
            mouseWheelZoom: 'ctrl'
          };
          croppieConfig = new Croppie(document.getElementById('editor'), opts); //a div
          uploader = uploaderConfig;
          croppie = croppieConfig;
          $update();
          if (uploader) {
            uploader.listen(function (result) {
              document.getElementById('cropped-image').src = '';
              document.getElementById('cut-button').classList.remove('disabled');
              croppie.bind({
                url: result
              });
            });
          }
          setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            return _regeneratorRuntime.wrap(function (_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  extraSetup();
                case 1:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          })), 2000);
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  })));
  var cutImage = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var resultBlob, resultCanvas;
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 1;
            return croppie.result({
              type: 'blob',
              format: 'jpeg',
              size: 'original'
            });
          case 1:
            resultBlob = _context5.sent;
            _context5.next = 2;
            return croppie.result({
              type: 'canvas',
              format: 'jpeg',
              size: 'original'
            });
          case 2:
            resultCanvas = _context5.sent;
            avatarBlob = resultBlob;
            if (document.getElementById('cropped-image').classList.contains('hideable')) {
              document.getElementById('cropped-image').classList.remove('hideable');
            }
            document.getElementById('cropped-image').src = resultCanvas;
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function cutImage() {
      return _ref6.apply(this, arguments);
    };
  }();
  var saveProfileImage = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var formUserData, referenceId, fileIds, result;
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            formUserData = new FormData();
            referenceId = $('#user-id').val();
            fileIds = $('#avatar-file-id').val();
            formUserData.append('ReferenceId', referenceId);
            formUserData.append('FileIds', fileIds);
            formUserData.append('user[]', avatarBlob);
            _context6.next = 1;
            return file.dispatch('uploadUserAvatar', formUserData);
          case 1:
            result = _context6.sent;
            if (!(result.status !== undefined && result.status !== 201)) {
              _context6.next = 2;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context6.abrupt("return");
          case 2:
            $f7.toast.show({
              text: locale.translate('user.edit.account.uploadAvatarOkMessage')
            });
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function saveProfileImage() {
      return _ref7.apply(this, arguments);
    };
  }();
  var savePersonal = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var formContactData, item, result;
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            formContactData = $f7.form.convertToData('#contact-form-edit');
            item = {
              ContactName: formContactData.ContactFirstName,
              ContactLastName: formContactData.ContactLastName,
              ContactSex: formContactData.ContactSex,
              ContactBirthDate: formContactData.ContactBirthDate
            };
            _context7.next = 1;
            return contact.dispatch('modifyData', item);
          case 1:
            result = _context7.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context7.next = 2;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context7.abrupt("return");
          case 2:
            $f7.toast.show({
              text: locale.translate('user.edit.personal.updateContactOkMessage')
            });
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function savePersonal() {
      return _ref8.apply(this, arguments);
    };
  }();
  var saveLicense = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var totalSelectedFiles, formImageData, referenceId, fileIds, i, result;
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            totalSelectedFiles = uploadPersonal.cachedFileArray.length;
            if (!(totalSelectedFiles < 2)) {
              _context8.next = 1;
              break;
            }
            $f7.toast.show({
              text: locale.translate('user.edit.personal.uploadLicenseRequiredLengthFilesMessage')
            });
            return _context8.abrupt("return");
          case 1:
            formImageData = new FormData();
            referenceId = $('#contact-reference-id').val();
            fileIds = $('#driver-license-file-list').val();
            formImageData.append('ReferenceId', referenceId);
            formImageData.append('FileIds', fileIds);
            for (i = 0; i < totalSelectedFiles; i++) {
              formImageData.append("driver[".concat(i, "]"), uploadPersonal.cachedFileArray[i]);
            }
            _context8.next = 2;
            return file.dispatch('uploadDriverLicense', formImageData);
          case 2:
            result = _context8.sent;
            if (!(result.status !== undefined && result.status !== 201)) {
              _context8.next = 3;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context8.abrupt("return");
          case 3:
            $f7.toast.show({
              text: locale.translate('user.edit.personal.uploadLicenseFileOkMessage')
            });
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function saveLicense() {
      return _ref9.apply(this, arguments);
    };
  }();
  var saveLocation = /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var formContactData, result;
      return _regeneratorRuntime.wrap(function (_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            formContactData = $f7.form.convertToData('#contact-address-form-edit');
            _context9.next = 1;
            return contact.dispatch('modifyAddressBookData', formContactData);
          case 1:
            result = _context9.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context9.next = 2;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context9.abrupt("return");
          case 2:
            $f7.toast.show({
              text: locale.translate('user.edit.location.updatedContactAdressMessage')
            });
          case 3:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function saveLocation() {
      return _ref0.apply(this, arguments);
    };
  }();
  var goNext = /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0() {
      var temp;
      return _regeneratorRuntime.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            temp = document.getElementsByClassName('tab-link-active')[0];
            document.getElementById(tabs[temp.id]).click();
          case 1:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }));
    return function goNext() {
      return _ref1.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="user-edit">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">${locale.translate('user.edit.title')}</div>
    </div>
  </div>
  <div class="fab fab-right-bottom">
    <a href="#" @click="${goNext}">
      <i class="material-symbols-outlined">arrow_forward</i>
    </a>
  </div>
  <div class="toolbar toolbar-top tabbar">
    <div class="toolbar-inner">
      <a id="tab-1-button" href="#tab-1" class="tab-link tab-link-active">${locale.translate('user.edit.tabs[0]')}</a>
      <a id="tab-2-button" href="#tab-2" class="tab-link">${locale.translate('user.edit.tabs[1]')}</a>
      <a id="tab-3-button" href="#tab-3" class="tab-link">${locale.translate('user.edit.tabs[2]')}</a>
      <a id="tab-4-button" href="#tab-4" class="tab-link">${locale.translate('user.edit.tabs[3]')}</a>
    </div>
  </div>
  <div class="tabs center-content">
    <div id="tab-1" class="page-content tab tab-active" data-name="user-data">
      <div class="block">
        <div class="block-title">${locale.translate('general.user')}</div>
        <form id="user-form-edit" class="list no-hairlines-md">
          <input id="user-id" name="userId" type="hidden" value="${userTemp.id}" />
          <ul>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('general.user')}</div>
                  <div class="item-input-wrap">
                    <input id="user-name" name="UserName" type="text" placeholder="${locale.translate('general.user')}" autocomplete="off" readonly value="${userTemp.name}"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('general.email')}</div>
                  <div class="item-input-wrap">
                    <input id="user-email" name="UserEmail" type="email" placeholder="${locale.translate('general.email')}" autocomplete="off" readonly value="${userTemp.email}"/>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </form>
        <div class="block-titles">${locale.translate('user.edit.account.avatarSelection')}</div>
        <div class="block inset">
          ${locale.translate('user.edit.account.instructionsLabel')}:
          <ol>
            <li>${locale.translate('user.edit.account.instructionsStepOne')}</li>
            <li>${locale.translate('user.edit.account.instructionsStepTwo')}</li>
            <li>${locale.translate('user.edit.account.instructionsStepThree')}</li>
            <li>${locale.translate('user.edit.account.instructionsStepFour')}</li>
          </ol>
        </div>
        <form id="user-avatar-form" class="list">
          <input id="avatar-file-id" name="AvatarFileId" type="hidden" value="${avatarFile.fileId}" />
          <ul>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.edit.account.avatarUploadImage')}:</div>
                  <div class="item-input-wrap">
                    <input id="user-avatar-file" name="UserAvatarFile" type="file" class="js-fileinput img-upload" accept="image/jpeg,image/jpg" />
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </form>
        <p class="grid grid-cols-3 xlarge-grid-cols-3">
          <div></div>
          <div>
            <a id="cut-button" href="#" class="button button-fill button-small disabled" @click="${cutImage}"><span class="material-icons">content_cut</span> ${locale.translate('general.cut')}</a>
          </div>
          <div></div>
        </p>
        <div class="set-together">
          <div id="editor">
          </div>
          <div id="edited-section" class="list block text-align-center">
            <img id="cropped-image" class="${isAvatarEmpty && $h`hideable`}" src="${avatarFile.url}" alt="Cut image" width="240" height="180" />
          </div>
        </div>
        <div class="block block-strong">
          <p class="grid grid-cols-3 xlarge-grid-cols-3">
            <div></div>
            <div>
              <a href="#" class="button button-small button-fill button-raised color-green" @click="${saveProfileImage}">
                <span class="material-symbols-outlined">save</span>${locale.translate('user.edit.account.avatarSave')}
              </a>
            </div>
            <div></div>
          </p>
        </div>
      </div>
    </div>
    <div id="tab-2" class="page-content tab" data-name="contact-personal-data">
      <div class="">
        <div class="block-title">${locale.translate('user.edit.personal.title')}</div>
        <form id="contact-form-edit" class="list no-hairlines-md">
          <input id="contact-reference-id" name="ContactReferenceId" type="hidden" value="${data.ContactId}" />
          <input id="driver-license-file-list" name="DriverLicenseFileList" type="hidden" value="${driverFileList}" />
          <ul>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.edit.personal.contactFirstName')}</div>
                  <div class="item-input-wrap">
                    <input id="contact-first-name" name="ContactFirstName" type="text" placeholder="${locale.translate('user.edit.personal.contactFirstName')}" autocomplete="off" value="${data.ContactName}"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.edit.personal.contactLastName')}</div>
                  <div class="item-input-wrap">
                    <input id="contact-last-name" name="ContactLastName" type="text" placeholder="${locale.translate('user.edit.personal.contactLastName')}" autocomplete="off" value="${data.ContactFirstLastName}"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <a id="smart-select-gender" class="item-link smart-select">
                <select name="ContactSex">
                  <option value="0" selected="${data.ContactSex == 0 && $h`selected`}">${locale.translate('general.select')}</option>
                  <option value="1" selected="${data.ContactSex == 1 && $h`selected`}">${locale.translate('user.edit.personal.contactGenderMale')}</option>
                  <option value="2" selected="${data.ContactSex == 2 && $h`selected`}" >${locale.translate('user.edit.personal.contactGenderFemale')}</option>
                  <option value="3" selected="${data.ContactSex == 3 && $h`selected`}" >${locale.translate('user.edit.personal.contactGenderX')}</option>
                </select>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-title">${locale.translate('user.edit.personal.contactGenderLabel')}</div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.edit.personal.contactBirthDateLabel')}</div>
                  <div class="item-input-wrap">
                    <input name="ContactBirthDate" type="text" placeholder="${locale.translate('user.edit.personal.contactBirthDateLabel')}" readonly="readonly" id="demo-calendar-default" />
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </form>
        <div class="block block-strong">
          <p class="grid grid-cols-3 xlarge-grid-cols-3">
            <div></div>
            <div>
              <a href="#" class="button button-small button-fill button-raised color-green" @click="${savePersonal}">
                <span class="material-symbols-outlined">person</span>${locale.translate('user.edit.personal.contactSave')}
              </a>
              </div>
            <div></div>
          </p>
        </div>
        <div class="block block-strong">
          <p class="grid grid-cols-3 xlarge-grid-cols-3">
            <div></div>
            <div>
              <a href="#" class="button button-small button-fill color-lime ${driverLicensePhotos.length < 1  && $h`disabled`}" @click=${openDriverBrowser}>
                <span class="material-symbols-outlined">image</span>${locale.translate('user.edit.personal.viewLicense')}
              </a>
            </div>
            <div></div>
          </p>
        </div>
      </div>
      <div class="custom-file-container list block text-align-center" data-upload-id="my-unique-id"></div>
      <div class="block block-strong">
        <p class="grid grid-cols-3 xlarge-grid-cols-3">
          <div></div>
          <div>
            <a href="#" class="button button-small button-fill button-raised color-green" @click="${saveLicense}">
              <span class="material-symbols-outlined">photo_camera</span>${locale.translate('user.edit.personal.licenseSave')}
            </a>
          </div>
          <div></div>
        </p>
      </div>
    </div>
    <div id="tab-3" class="page-content tab" data-name="contact-address-data">
      <div class="">
        <div class="block-title">${locale.translate('user.edit.location.title')}</div>
        <form id="contact-address-form-edit" class="list no-hairlines-md">
          <input id="contact-address-book-id" name="ContactAddressBookId" type="hidden" value="${data.ContactAddressBookId}" />
          <ul>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.edit.location.addressLabel')}</div>
                  <div class="item-input-wrap">
                    <input id="contact-address" name="ContactAddress" type="text" autocomplete="off" value="${data.ContactAddress}"
                      placeholder="${locale.translate('user.edit.location.streetPlaceHolder')}"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.edit.location.streetLabel')}</div>
                  <div class="item-input-wrap">
                    <input id="contact-address-street" name="ContactAddressStreet" type="text" placeholder="${locale.translate('user.edit.location.streetPlaceHolder')}" autocomplete="off" value="${data.ContactAddressStreet}"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.edit.location.externalNumber')}</div>
                  <div class="item-input-wrap">
                    <input id="contact-address-exterior-number" name="ContactAddressExteriorNumber" type="number" placeholder="${locale.translate('user.edit.location.externalNumberPlaceHolder')}" autocomplete="off" value="${data.ContactAddressExteriorNumber}"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.edit.location.district')}</div>
                  <div class="item-input-wrap">
                    <input id="contact-district" name="ContactDistrict" type="text" placeholder="${locale.translate('user.edit.location.districtPlaceHolder')}" autocomplete="off" value="${data.ContactDistrict}"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.edit.location.zipCode')}</div>
                  <div class="item-input-wrap">
                    <input id="contact-zipcode" name="ContactZipcode" type="text" maxlength="7" placeholder="${locale.translate('user.edit.location.zipCodePlaceHolder')}" autocomplete="off" value="${data.ContactZipcode}"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.edit.location.phone')}</div>
                  <div class="item-input-wrap">
                    <input id="contact-cellphone" name="ContactCellphone" type="text" placeholder="${locale.translate('user.edit.location.phonePlaceHolder')}" autocomplete="off" value="${data.ContactCellphone}"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <a id="smart-select-province" href="#" class="item-link smart-select">
                <select id="contact-province" name="ContactProvinceId" @change="${setProvinceLocalities}">
                ${provinceList.map((item) => $h`
                  <option value="${item.id}" selected="${Number(item.id) == Number(data.ContactProvinceId) && $h`selected`}" >${item.text}</option>
                `)}  
                </select>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-title">${locale.translate('user.edit.location.province')}</div>
                    <div class="item-after">Select</div>
                  </div>
                </div>
              </a>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.edit.location.locality')}</div>
                  <div class="item-input-wrap">
                    <input id="contact-locality" name="ContactLocalityName" type="text" placeholder="${locale.translate('user.edit.location.localityPlaceHolder')}" autocomplete="off" value="${data.ContactLocalityName}" />
                    <input id="contact-locality-id" name="ContactLocalityId" type="hidden" value="${data.ContactLocalityId}"/>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </form>
        <div class="block block-strong">
          <p class="grid grid-cols-3 xlarge-grid-cols-3">
            <div></div>
            <div>
              <a href="#" class="button button-small button-fill button-raised color-green" @click="${saveLocation}">
                <span class="material-symbols-outlined">import_contacts</span>${locale.translate('user.edit.location.addressSave')}
              </a>
            </div>
            <div></div>
          </p>
        </div>
      </div>
    </div>
    <${CarDataTab} details=${props}/>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = '9e6db8a283';
export default framework7Component;